import {Routes} from '@angular/router';

import {InnerNavComponent} from './inner-nav.component';
import {TaskComponent} from '../task/task.component';
import {ReportsComponent} from '../reports/reports.component';
import {ReportSummaryComponent} from '../report-summary/report-summary.component';
import {AdminComponent} from '../admin/admin.component';
import {CorrespondenceComponent} from "../correspondence/correspondence.component";


export const innerNavRoute: Routes = [
  {
    path: '',
    component: InnerNavComponent,
    outlet: 'innernav'
  },
  {
    path: 'task',
    component: TaskComponent
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'correspondence',
    component: CorrespondenceComponent,
  },
  {
    path: 'report-summary',
    component: ReportSummaryComponent
  },
  {
    path: 'admin',
    component: AdminComponent
  },
];



// WEBPACK FOOTER //
// ./src/app/inner-nav/inner-nav.route.ts